var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.64,405.49V438.4h-4.73V442h4.73v22h88.45V444h-6.55v-4.36h6.55V433H344v-3h-3.46V405.49Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.6 405.59 317.6 463.99 341.09 464.08 341.09 443.59 334.54 443.59 334.54 439.59 341.09 439.73 341.09 433.18 344.06 433.18 344 429.8 340.54 429.7 340.54 405.49 317.6 405.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.43,438.24c0,.14-20.55.26-45.89.26s-45.89-.12-45.89-.26,20.54-.26,45.89-.26S340.43,438.1,340.43,438.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.54,441.92c0,.14-19.23.26-43,.26s-42.94-.12-42.94-.26,19.22-.26,42.94-.26S334.54,441.77,334.54,441.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.43,449.81c0,.14-19.58.26-43.73.26S253,450,253,449.81s19.58-.26,43.73-.26S340.43,449.66,340.43,449.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,429.66c0,.14-20.38.26-45.51.26S253,429.8,253,429.66s20.37-.26,45.52-.26S344,429.51,344,429.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.43,409.5c0,.15-19.58.26-43.73.26S253,409.65,253,409.5s19.58-.26,43.73-.26S340.43,409.36,340.43,409.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.54,419.76c0,.15-19.53.26-43.62.26s-43.62-.11-43.62-.26,19.53-.26,43.62-.26S340.54,419.62,340.54,419.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.09,457.7c0,.14-19.73.26-44.06.26S253,457.84,253,457.7s19.72-.26,44.06-.26S341.09,457.55,341.09,457.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.63,114.52a1,1,0,0,1,0-.21c0-.16,0-.36,0-.61q0-.83,0-2.31c0-2-.05-5-.08-8.63l.14.14-44.45.09.23-.23h0v6c0,2,0,3.89,0,5.78l-.22-.22,31.68.1,9.35.06,2.52,0,.66,0h.24a.85.85,0,0,1-.21,0h-.63l-2.48,0-9.3.06-31.83.1H438v-12h0l.22-.22,44.45.08h.14v.13c0,3.72-.06,6.66-.08,8.71,0,1,0,1.74,0,2.29,0,.23,0,.42,0,.57A1.14,1.14,0,0,1,482.63,114.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.65,102.76a2,2,0,0,1,0-.22c0-.17,0-.37,0-.62,0-.58,0-1.37,0-2.36,0-2.06-.05-5-.09-8.56l.16.17-26.7.06c-.2.2.28-.28.23-.22h0v3.06c0,1,0,2,0,3v5.7l-.22-.21,19.1.1,5.57.06,1.5,0a3.17,3.17,0,0,1,.53,0,2.62,2.62,0,0,1-.48,0l-1.46,0-5.51.06L462,103h-.22V97.06c0-1,0-2,0-3V91h0c-.05,0,.43-.43.23-.23l26.7.06h.17V91c0,3.63-.07,6.57-.09,8.66,0,1,0,1.75,0,2.32A4.08,4.08,0,0,1,488.65,102.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,306s0-.08,0-.21,0-.36,0-.61c0-.55,0-1.32,0-2.31,0-2,0-4.95-.07-8.63l.13.14-44.44.09.23-.23h0V306l-.22-.22,31.67.1,9.35.06,2.53,0h.66a1,1,0,0,1,.23,0h-.2l-.63,0-2.49,0-9.29.06-31.83.1h-.22V306c0-1.89,0-3.82,0-5.78v-6h0l.23-.23,44.44.09h.14v.14c0,3.72-.06,6.66-.07,8.71,0,1,0,1.74,0,2.28,0,.24,0,.43,0,.58S362,306,362,306Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,294.21s0-.08,0-.22,0-.38,0-.63c0-.57,0-1.36,0-2.35,0-2.07-.05-5-.09-8.56l.16.17-26.7.06c-.21.2.27-.28.22-.23h0v6.05c0,2,0,3.87,0,5.7l-.21-.21,19.1.1,5.56.06,1.51,0,.53,0a2.76,2.76,0,0,1-.48,0l-1.46,0-5.51.06-19.25.11h-.22v-.22c0-1.83,0-3.73,0-5.7v-6.05h0c-.05.05.43-.43.23-.22l26.7.06h.17v.16c0,3.62-.06,6.57-.08,8.66,0,1,0,1.75,0,2.32S368,294.22,368,294.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,75.14a1,1,0,0,1,0-.21c0-.16,0-.36,0-.61,0-.55,0-1.32,0-2.31,0-2,0-5-.07-8.63l.13.14-44.44.09.23-.23h0v3c0,1,0,2,0,3v5.78l-.22-.22,31.67.1,9.35.06,2.53,0,.66,0H335a.67.67,0,0,1-.21,0l-.63,0-2.49,0-9.29.06-31.83.1h-.22v-.22c0-1.89,0-3.82,0-5.78v-6h0l.23-.22,44.44.08h.14v.14c0,3.72-.06,6.66-.07,8.71,0,1,0,1.74,0,2.28,0,.24,0,.43,0,.58S335,75.15,335,75.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,63.38s0-.08,0-.22v-.62c0-.58,0-1.37,0-2.36,0-2.06-.05-5-.09-8.56l.16.17-26.7.06c-.21.2.27-.28.22-.22h0v6c0,2,0,3.88,0,5.7l-.21-.21,19.1.1,5.56.06,1.51,0a3.28,3.28,0,0,1,.53,0,2.76,2.76,0,0,1-.48,0l-1.46,0-5.51.06-19.25.1h-.22v-.22c0-1.82,0-3.73,0-5.7v-6h0c-.05,0,.43-.43.23-.23l26.7.06h.17v.16c0,3.63-.06,6.57-.08,8.66,0,1,0,1.75,0,2.32S341,63.39,341,63.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.46,55a.82.82,0,0,1,0-.22c0-.15,0-.35,0-.6q0-.83,0-2.31c0-2-.05-5-.08-8.63l.14.14L38,43.46c.1-.1-.23.22.22-.23h0v6c0,2,0,3.9,0,5.79L38,54.77l31.68.1,9.35.06,2.52,0h.66l.24,0h-.21l-.63,0-2.48,0-9.3.06L38,55.21h-.22v-12h0c.45-.45.12-.13.23-.23l44.44.09h.14v.14c0,3.71-.06,6.66-.08,8.71,0,1,0,1.74,0,2.28,0,.24,0,.43,0,.58A1.31,1.31,0,0,1,82.46,55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.49,43.23a.61.61,0,0,1,0-.22l0-.63c0-.58,0-1.36,0-2.35,0-2.07,0-5-.09-8.56l.17.16-26.71.07.23-.23h0v3.05c0,1,0,2,0,3v5.7L61.78,43l19.1.11,5.57.06,1.5,0,.54,0a3,3,0,0,1-.49,0l-1.46,0L81,43.34l-19.25.11h-.21V37.53c0-1,0-2,0-3V31.49h0l.23-.23,26.71.07h.16v.16c0,3.62-.07,6.57-.09,8.65,0,1,0,1.76,0,2.33A7.4,7.4,0,0,1,88.49,43.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.24,118.87a1.66,1.66,0,0,1,0-.21c0-.16,0-.35,0-.6,0-.56,0-1.33,0-2.32,0-2,0-4.94-.08-8.62l.14.13-44.44.09.22-.22h0v11.73l-.22-.22,31.67.1,9.35.07,2.53,0h.89s-.06,0-.2,0h-.64l-2.48,0-9.3.07-31.82.1h-.22v-12h0c.45-.46.13-.13.23-.23l44.44.09h.14v.14c0,3.71-.06,6.66-.08,8.71q0,1.45,0,2.28c0,.24,0,.43,0,.58S176.25,118.88,176.24,118.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.27,107.12a1.17,1.17,0,0,1,0-.23c0-.17,0-.37,0-.62,0-.58,0-1.37,0-2.36,0-2.06-.05-5-.08-8.55l.16.16-26.7.07c-.21.2.27-.28.22-.23h0v6c0,2,0,3.87,0,5.7l-.22-.22,19.11.1,5.56.06,1.5,0,.54,0a4.23,4.23,0,0,1-.49,0l-1.45,0-5.52.06-19.25.1h-.21v-.21c0-1.83,0-3.74,0-5.7v-6h0l.23-.23,26.7.07h.16v.16c0,3.62-.06,6.57-.09,8.65,0,1,0,1.75,0,2.32A7.51,7.51,0,0,1,182.27,107.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.7,
    y: 150.35,
    width: 35.06,
    height: 9.28,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.93,169.4s0-.06,0-.17,0-.28,0-.48c0-.43,0-1,0-1.82,0-1.6,0-3.9-.06-6.81l.1.11-35.06.07.18-.18h0v9.26l-.18-.18,25,.08,7.37,0,2,0h0l-1.95,0-7.34.05-25.11.08h-.17v-.17c0-1.49,0-3,0-4.56v-4.7h0c.36-.35.1-.1.18-.18l35.06.07H332v.1c0,2.93,0,5.26-.06,6.87,0,.77,0,1.37,0,1.81,0,.18,0,.33,0,.45S331.94,169.4,331.93,169.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.78,
    y: 220.83,
    width: 35.06,
    height: 9.28,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,239.88s0-.06,0-.17v-.48c0-.43,0-1,0-1.82,0-1.6,0-3.9-.06-6.81l.11.11-35.06.07.18-.18h0v9.26l-.18-.18,25,.08,7.37.05,2,0h0l-2,0-7.33.05-25.11.08h-.17v-.17c0-1.49,0-3,0-4.56v-4.7h0c.36-.35.1-.1.18-.18l35.06.07h.11v.11c0,2.93,0,5.26-.06,6.87,0,.77,0,1.37,0,1.8,0,.19,0,.34,0,.46S467,239.88,467,239.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.35,
    y: 323.43,
    width: 35.06,
    height: 9.28,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.59,342.47a1.15,1.15,0,0,1,0-.17v-.47q0-.66,0-1.83c0-1.6,0-3.9-.06-6.8l.11.1-35.06.07.18-.17h0v2.36c0,.78,0,1.56,0,2.34v4.56l-.17-.17,25,.08,7.38.05,2,0h.05l-2,0-7.33.05-25.11.08h-.18v-9.44h0l.18-.18,35.06.07h.11v.11c0,2.93,0,5.25-.06,6.87q0,1.15,0,1.8v.45A.72.72,0,0,1,186.59,342.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 22.35,
    width: 82.58,
    height: 119.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.78,
    y: 22.35,
    width: 82.58,
    height: 119.7,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.04,
    y: 35.32,
    width: 62.06,
    height: 93.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.1,129.09s0-.16,0-.46,0-.75,0-1.33c0-1.18,0-2.91,0-5.15,0-4.49,0-11-.06-19.31,0-16.54-.06-39.95-.1-67.52l.21.2-62.06,0h0l.22-.22c0,35.37,0,68,0,93.77l-.18-.18,45.17.09,12.48.05,3.27,0c.75,0,1.14,0,1.14,0l-1.1,0-3.24,0-12.44,0-45.28.1h-.18v-.18c0-25.78,0-58.4-.05-93.77v-.23H368l62.06,0h.2v.21c0,27.62-.07,51.09-.1,67.65,0,8.26,0,14.79-.05,19.27,0,2.23,0,3.94,0,5.11,0,.56,0,1,0,1.3S430.1,129.09,430.1,129.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.59,22.35a13.61,13.61,0,0,1-1.47,2.14c-1,1.28-2.32,3-3.88,4.92s-3,3.55-4.08,4.74A13.62,13.62,0,0,1,429.34,36a15.93,15.93,0,0,1,1.58-2.07l4-4.82,4-4.83A15.15,15.15,0,0,1,440.59,22.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.41,128.78a76.45,76.45,0,0,0,10.83,13.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.24,142.32a12.48,12.48,0,0,1-1.89-1.72,57,57,0,0,1-4.08-4.6,60.8,60.8,0,0,1-3.6-5,13,13,0,0,1-1.26-2.22,17.2,17.2,0,0,1,1.53,2c.91,1.28,2.19,3,3.68,4.9s2.92,3.5,4,4.67A17.77,17.77,0,0,1,441.24,142.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.76,142l10.82-13.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.58,128.61a81.58,81.58,0,0,1-5.23,6.81,83.21,83.21,0,0,1-5.59,6.54,84.23,84.23,0,0,1,5.24-6.82A85.69,85.69,0,0,1,368.58,128.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.78,22.35A81.06,81.06,0,0,1,363,28.63a78.58,78.58,0,0,1,4.9,6.55,74,74,0,0,1-5.26-6.27A73.67,73.67,0,0,1,357.78,22.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.98,
    y: 54.36,
    width: 20.78,
    height: 59,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,245.49a1.12,1.12,0,0,1,0-.22c0-.15,0-.35,0-.6,0-.55,0-1.32,0-2.31,0-2,0-5-.07-8.63l.14.14L33.06,234c.1-.11-.23.22.23-.23h0v5.95c0,2,0,3.9,0,5.79l-.22-.22,31.67.1,9.35.06,2.53,0h.66l.24,0H77.3l-.63,0-2.48,0-9.3.06-31.83.1h-.22v-6c0-1,0-2,0-3v-3h0l.23-.23,44.45.09h.14v.14c0,3.71,0,6.66-.07,8.71,0,1,0,1.74,0,2.28,0,.24,0,.43,0,.58A1.31,1.31,0,0,1,77.51,245.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.53,233.73s0-.08,0-.22l0-.63c0-.58,0-1.36,0-2.36,0-2.06,0-5-.09-8.55l.16.16-26.7.07.22-.23h0v6c0,2,0,3.87,0,5.7l-.21-.22,19.1.11,5.57.06,1.5,0,.53,0a2.62,2.62,0,0,1-.48,0l-1.46,0-5.51.06-19.25.1h-.22v-.22c0-1.83,0-3.74,0-5.7v-6h0l.23-.23,26.7.07h.17V222c0,3.62-.07,6.57-.09,8.65,0,1,0,1.76,0,2.32A5.65,5.65,0,0,1,83.53,233.73Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.49,464.08c0,.14-105.44.26-235.48.26s-235.5-.12-235.5-.26,105.42-.26,235.5-.26S485.49,463.94,485.49,464.08Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.02,
    y: 29.39,
    width: 100.53,
    height: 71.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.55,29.39h-.49l-1.42,0-5.49,0-20.66.06L164,29.63l.24-.24c0,21.72,0,46.14,0,71.89h0L164,101l100.53,0-.21.21c0-21.8.08-39.74.11-52.26,0-6.26,0-11.16.05-14.5,0-1.67,0-2.94,0-3.82s0-1.32,0-1.32,0,.43,0,1.28,0,2.12,0,3.77c0,3.34,0,8.22.06,14.46,0,12.55.06,30.54.11,52.39v.21h-.21l-100.53,0h-.26v-.26h0c0-25.75,0-50.17,0-71.89v-.24H164l72.63.12,20.6.06,5.44,0,1.39,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.6,40.48h-18a1.6,1.6,0,0,0-1.6,1.6h0a1.61,1.61,0,0,0,1.6,1.61h18a1.61,1.61,0,0,0,1.61-1.61h0A1.61,1.61,0,0,0,193.6,40.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71,90.69h-8.1a1.6,1.6,0,0,0-1.6,1.6h0a1.61,1.61,0,0,0,1.6,1.61h8.1a1.6,1.6,0,0,0,1.6-1.6h0A1.61,1.61,0,0,0,183.71,90.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,90.69h-8.1a1.6,1.6,0,0,0-1.6,1.6h0a1.61,1.61,0,0,0,1.6,1.61H201a1.6,1.6,0,0,0,1.6-1.6h0A1.6,1.6,0,0,0,201,90.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.33,90.69h-8.09a1.61,1.61,0,0,0-1.61,1.6h0a1.61,1.61,0,0,0,1.6,1.61h8.1a1.61,1.61,0,0,0,1.61-1.6h0A1.61,1.61,0,0,0,218.33,90.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.64,90.69h-8.09a1.61,1.61,0,0,0-1.61,1.6h0a1.61,1.61,0,0,0,1.61,1.61h8.09a1.61,1.61,0,0,0,1.61-1.6h0A1.61,1.61,0,0,0,235.64,90.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,90.69h-8.09a1.61,1.61,0,0,0-1.61,1.6h0a1.61,1.61,0,0,0,1.61,1.61H253a1.61,1.61,0,0,0,1.61-1.6h0A1.61,1.61,0,0,0,253,90.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.64,90.69h-8.09a1.61,1.61,0,0,0-1.61,1.6h0a1.61,1.61,0,0,0,1.61,1.61h8.09a1.61,1.61,0,0,0,1.61-1.6h0A1.61,1.61,0,0,0,235.64,90.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.46,
    y: 50.41,
    width: 4.22,
    height: 35.96,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.61,
    y: 62.62,
    width: 4.22,
    height: 23.74,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.75,
    y: 54.88,
    width: 4.22,
    height: 31.67,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.9,
    y: 51.8,
    width: 4.22,
    height: 34.57,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.04,
    y: 63.36,
    width: 4.22,
    height: 23.01,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.19,
    y: 67.87,
    width: 4.22,
    height: 18.5,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.33,
    y: 54.1,
    width: 4.22,
    height: 32.27,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.48,
    y: 59.92,
    width: 4.22,
    height: 26.45,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.63,
    y: 55.27,
    width: 4.22,
    height: 31.1,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.77,
    y: 65.18,
    width: 4.22,
    height: 21.19,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.61,
    y: 62.62,
    width: 4.22,
    height: 23.74,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.9,
    y: 51.8,
    width: 4.22,
    height: 34.57,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.19,
    y: 67.87,
    width: 4.22,
    height: 18.5,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.48,
    y: 59.92,
    width: 4.22,
    height: 26.45,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.77,
    y: 65.18,
    width: 4.22,
    height: 21.19,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.11,51.8s0,.05,0,.16v.48c0,.43,0,1.06,0,1.87,0,1.64,0,4,0,7.07,0,6.09,0,14.78,0,25.17l-.1-.12,28,0,40.89,0,12.39,0,3.37,0,.87,0h.3l-.3,0h-.87l-3.37,0L241,86.65l-40.89,0-28,0H172v-.12c0-10.39,0-19.08,0-25.17,0-3,0-5.43,0-7.07,0-.81,0-1.44,0-1.87,0-.2,0-.36,0-.48A.92.92,0,0,1,172.11,51.8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--document-2--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.23,
    y: 65.34,
    width: 94.35,
    height: 122.28,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.58,187.62s0-.21,0-.59,0-1,0-1.72c0-1.52,0-3.75,0-6.65,0-5.81,0-14.3-.06-25,0-21.49-.07-52-.12-88.27l.24.23-94.34,0h0l.26-.26c0,45.41,0,87.54,0,122.27l-.22-.21,68.49.11,19.09.06,5,0,1.74,0-1.69,0-5,0-19.05.06-68.62.11H38v-.22c0-34.73,0-76.86-.05-122.27v-.26h.27l94.34,0h.23v.23c0,36.31-.09,66.9-.11,88.42,0,10.73,0,19.2-.07,25,0,2.88,0,5.1,0,6.6,0,.74,0,1.3,0,1.69S132.58,187.62,132.58,187.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.71,89.21l32.15.06a1.89,1.89,0,0,0,1.9-1.89h0a1.89,1.89,0,0,0-1.89-1.9l-32.15-.06a1.9,1.9,0,0,0-1.9,1.89h0A1.9,1.9,0,0,0,48.71,89.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.76,96.54l32.15.06a1.89,1.89,0,0,0,1.9-1.89h0a1.9,1.9,0,0,0-1.89-1.9l-32.15-.06a1.9,1.9,0,0,0-1.9,1.9h0A1.89,1.89,0,0,0,48.76,96.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.81,103.88l32.15.06a1.9,1.9,0,0,0,1.89-1.9h0a1.9,1.9,0,0,0-1.89-1.9l-32.15,0A1.88,1.88,0,0,0,46.92,102h0A1.9,1.9,0,0,0,48.81,103.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.85,111.21l32.15.06a1.9,1.9,0,0,0,1.9-1.89h0a1.89,1.89,0,0,0-1.89-1.9l-32.15-.06a1.89,1.89,0,0,0-1.9,1.89h0A1.9,1.9,0,0,0,48.85,111.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9,118.54l32.15.06a1.9,1.9,0,0,0,1.9-1.89h0a1.9,1.9,0,0,0-1.89-1.9l-32.15-.06a1.9,1.9,0,0,0-1.9,1.89h0A1.89,1.89,0,0,0,48.9,118.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,125.87l32.14.06A1.89,1.89,0,0,0,83,124h0a1.88,1.88,0,0,0-1.89-1.9L49,122.08a1.91,1.91,0,0,0-1.9,1.89h0A1.9,1.9,0,0,0,49,125.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,133.21l32.15,0a1.88,1.88,0,0,0,1.9-1.89h0a1.91,1.91,0,0,0-1.89-1.9L49,129.41a1.9,1.9,0,0,0-1.9,1.9h0A1.91,1.91,0,0,0,49,133.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.67,125.87l32.14.06a1.89,1.89,0,0,0,1.9-1.89h0a1.88,1.88,0,0,0-1.89-1.9l-32.15-.06a1.91,1.91,0,0,0-1.9,1.89h0A1.9,1.9,0,0,0,89.67,125.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.71,133.21l32.15,0a1.88,1.88,0,0,0,1.9-1.89h0a1.91,1.91,0,0,0-1.89-1.9l-32.15-.05a1.88,1.88,0,0,0-1.9,1.89h0A1.91,1.91,0,0,0,89.71,133.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,140.94l32.15.06a1.9,1.9,0,0,0,1.9-1.89h0a1.9,1.9,0,0,0-1.89-1.9l-32.15-.06a1.89,1.89,0,0,0-1.9,1.89h0A1.89,1.89,0,0,0,89.76,140.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.81,148.67l32.15.06a1.89,1.89,0,0,0,1.9-1.89h0a1.9,1.9,0,0,0-1.89-1.9l-32.15-.06a1.9,1.9,0,0,0-1.9,1.89h0A1.89,1.89,0,0,0,89.81,148.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.86,156.4l32.15.06a1.9,1.9,0,0,0,1.9-1.89h0a1.9,1.9,0,0,0-1.9-1.9l-32.14-.06a1.9,1.9,0,0,0-1.9,1.9h0A1.89,1.89,0,0,0,89.86,156.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.91,164.14l32.15.06a1.91,1.91,0,0,0,1.9-1.9h0a1.9,1.9,0,0,0-1.9-1.89l-32.14-.06a1.88,1.88,0,0,0-1.9,1.89h0A1.88,1.88,0,0,0,89.91,164.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,171.87l32.15.06A1.89,1.89,0,0,0,124,170h0a1.88,1.88,0,0,0-1.89-1.9L90,168.08A1.89,1.89,0,0,0,88.07,170h0A1.88,1.88,0,0,0,90,171.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.55,179.81l73.08.13a1.89,1.89,0,0,0,1.9-1.89h0a1.89,1.89,0,0,0-1.89-1.9L48.55,176a1.27,1.27,0,0,0-1.27,1.27v1.25A1.27,1.27,0,0,0,48.55,179.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.66,79.66l21.27,0a1.89,1.89,0,0,0,1.9-1.89h0a1.9,1.9,0,0,0-1.89-1.9l-21.28,0a1.91,1.91,0,0,0-1.9,1.89h0A1.9,1.9,0,0,0,48.66,79.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.85,
    y: 140.8,
    width: 29.66,
    height: 26.99,
    rx: 6.89,
    transform: "translate(0.28 -0.12) rotate(0.1)",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.84,161.47a.72.72,0,0,1,.3-.58L58.51,154c.74-.62,1.75-1.09,3.72.13h0l4.59,2.22a.7.7,0,0,0,.83-.15l6.49-6.69a2.06,2.06,0,0,1,3,.17l2.21,2.62a.71.71,0,0,1,.17.46l0,10.83a4.45,4.45,0,0,1-4.33,4.26l-20.87,0a4.51,4.51,0,0,1-4.47-4.58Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8,147.78A3,3,0,1,1,60.62,145,3,3,0,0,1,63.8,147.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M121.65,99.77a15.55,15.55,0,1,1-15.8-15.37A15.6,15.6,0,0,1,121.65,99.77Zm-23,.37A7.44,7.44,0,1,0,106,92.55,7.47,7.47,0,0,0,98.67,100.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.65,99.77a15.6,15.6,0,0,1-15.3,15.87l-.13-8.15A7.47,7.47,0,0,0,106,92.55l-.14-8.15A15.6,15.6,0,0,1,121.65,99.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.75,116.89a17.76,17.76,0,0,1-18.19-17.7L99.05,99c.08,4.82,3.74,7.85,8.54,7.77Z",
    style: {
      fill: "#46C5FB"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.45,171.66,198,173a22.63,22.63,0,1,1,4.21-6.94h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.45,171.66s-.06-.12-.2-.36-.34-.61-.61-1.07c-.55-1-1.35-2.39-2.4-4.22a0,0,0,0,0-.07,0l0,0h0l.1,0a22.78,22.78,0,0,0,1.35-11,22.34,22.34,0,0,0-.72-3.45c-.17-.59-.4-1.17-.61-1.77a12.41,12.41,0,0,0-.76-1.77,22.4,22.4,0,0,0-4.88-6.7A22.87,22.87,0,0,0,179,135.28a23.22,23.22,0,0,0-10,3.38,20.15,20.15,0,0,0-2.24,1.58,12.78,12.78,0,0,0-1,.91c-.34.32-.7.61-1,1a23.12,23.12,0,0,0-1.81,2.13l-.83,1.14c-.24.41-.48.82-.73,1.22A22.78,22.78,0,0,0,160.24,167a22.76,22.76,0,0,0,21.49,13.64,24.61,24.61,0,0,0,3.73-.41,29.14,29.14,0,0,0,3.38-.95A22.49,22.49,0,0,0,198,173l0,0,5.58-1,1.41-.26.47-.1-.5.08-1.43.24-5.55,1,0,0a22.45,22.45,0,0,1-9.16,6.19,32,32,0,0,1-3.35.93,24.52,24.52,0,0,1-3.7.39,22.59,22.59,0,0,1-21.25-13.53,22.53,22.53,0,0,1,1.13-20.19l.72-1.2c.26-.39.55-.76.82-1.13a22.65,22.65,0,0,1,1.79-2.11c.3-.35.66-.63,1-1a12.52,12.52,0,0,1,1-.9,21,21,0,0,1,2.21-1.56,23,23,0,0,1,9.86-3.35,22.57,22.57,0,0,1,22.29,12.64,14.16,14.16,0,0,1,.76,1.76c.2.59.44,1.17.61,1.75a22,22,0,0,1,.72,3.42A22.81,22.81,0,0,1,202.14,166a.05.05,0,0,0,0,.07,0,0,0,0,0,.06,0h-.08l2.44,4.14c.27.47.49.83.64,1.08S205.45,171.66,205.45,171.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.69,164.31a7.55,7.55,0,1,1,4.78-1.69A7.58,7.58,0,0,1,180.69,164.31Zm0-13.14a5.58,5.58,0,1,0,5.57,5.57A5.58,5.58,0,0,0,180.69,151.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.67,166.74a1,1,0,0,1-.7-.29l-4.39-4.28a1,1,0,1,1,1.39-1.43l4.4,4.28a1,1,0,0,1-.7,1.72Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.11,151a7.32,7.32,0,0,1,.54-12.84l9-1.71q-.34,16.63-.48,33.27a12.78,12.78,0,0,1-6.37-2.66c-1.72-1.55-2.65-4.16-1.65-6.23a5.78,5.78,0,0,1-1-9.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.13,151.14l-1.26-5-21.65-4.74c-7.18-1-15.18,5.89-15.86,13-.76,7.88-1.36,17.52-.6,23.44,1.54,11.89,10.72,13.68,10.72,13.68l-.74,11.69c-.3,6.83,5.51,8.51,12.45,8.81h0c6.79.29,11.7-5.08,12.22-11.74Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.24,164.05a1.53,1.53,0,0,0,1.44,1.58,1.47,1.47,0,0,0,1.63-1.32,1.53,1.53,0,0,0-1.44-1.58A1.46,1.46,0,0,0,226.24,164.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.75,159.44c.18.2,1.38-.61,3-.56s2.85.91,3,.72-.09-.45-.61-.85a4.26,4.26,0,0,0-2.43-.81,4.08,4.08,0,0,0-2.43.69C225.84,159,225.65,159.35,225.75,159.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.72,164.61a1.52,1.52,0,0,0,1.44,1.57,1.46,1.46,0,0,0,1.63-1.32,1.52,1.52,0,0,0-1.43-1.57A1.47,1.47,0,0,0,241.72,164.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.07,160.24c.18.21,1.38-.61,3-.55s2.85.91,3,.71-.09-.45-.61-.84a4.26,4.26,0,0,0-2.43-.82,4.08,4.08,0,0,0-2.43.69C242.16,159.8,242,160.15,242.07,160.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.65,172.17a11.63,11.63,0,0,0-2.68-.56c-.42-.05-.82-.15-.88-.43a2.1,2.1,0,0,1,.32-1.23l1.35-3.14c1.89-4.47,3.27-8.15,3.08-8.22s-1.86,3.49-3.74,8c-.46,1.1-.89,2.15-1.3,3.16a2.38,2.38,0,0,0-.28,1.63,1.08,1.08,0,0,0,.68.63,3,3,0,0,0,.72.12A10.3,10.3,0,0,0,235.65,172.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.49,191.48a32.31,32.31,0,0,0,16.66-3.75s-4.44,8.34-16.87,6.88Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.23,176.13a3,3,0,0,1,2.72-1,2.76,2.76,0,0,1,1.86,1,1.7,1.7,0,0,1,.07,2,2,2,0,0,1-2.2.47,6.25,6.25,0,0,1-2.08-1.31,1.68,1.68,0,0,1-.46-.5.54.54,0,0,1,0-.61",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.51,173.45c-.27,0-.33,1.75-1.91,3s-3.5,1-3.52,1.21.41.36,1.23.4a4.49,4.49,0,0,0,2.93-.9,3.83,3.83,0,0,0,1.49-2.49C240.82,173.89,240.63,173.45,240.51,173.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.1,154.65c.19.42,1.54.06,3.18.1s3,.42,3.18,0c.08-.2-.2-.59-.77-1a4.8,4.8,0,0,0-2.44-.69,4.51,4.51,0,0,0-2.41.61C242.28,154.06,242,154.44,242.1,154.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,153.84c.28.38,1.44,0,2.82,0s2.53.33,2.81,0c.12-.18,0-.56-.55-.93a4.11,4.11,0,0,0-4.53,0C226,153.28,225.85,153.65,226,153.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.12,143.52a7.48,7.48,0,0,1-2.74-7.88,8.67,8.67,0,0,1,6.14-5.92,9.9,9.9,0,0,1,1.8-.27,8,8,0,0,1,3.87-1,4.14,4.14,0,0,1,3.26-3.1,10.1,10.1,0,0,1,4.75.33,8.14,8.14,0,0,1,13,1,6.81,6.81,0,0,1,5.91-.23A6.62,6.62,0,0,1,257.8,131a6.6,6.6,0,0,1,4.64,2.33,6,6,0,0,1,1,1.7,6.09,6.09,0,0,1,1.1,2.43,7.6,7.6,0,0,1,6.22,5.7,7.45,7.45,0,0,1-3.29,7.7,6.7,6.7,0,0,1,1.79,5.72,6.8,6.8,0,0,1-3.6,4.83,8.4,8.4,0,0,1-.88,6.67,4.18,4.18,0,0,1-2.23,1.92,1.54,1.54,0,0,1-.21.45c-.77,1.12-2.58.57-3.62-.31-2.55-2.12-3.85-5.36-4.49-8.58s-.72-6.53-1.33-9.76c0-.07,0-.14,0-.22a8.77,8.77,0,0,0-1.66-3.69,23.38,23.38,0,0,1-3,1.77A10,10,0,0,1,236.82,147a14.62,14.62,0,0,1-9.28,3c-3.32-.1-6.59-.81-9.08-3a4.49,4.49,0,0,1-1.38-2.09C216.91,144.4,217.51,143.68,218.12,143.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.78,165.65c.17-.08,6.54-2,6.65,4.46s-6.56,5.26-6.57,5.07S259.78,165.65,259.78,165.65Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.84,172.69s.11.08.31.16a1.19,1.19,0,0,0,.86,0,2.8,2.8,0,0,0,1.28-2.54,3.63,3.63,0,0,0-.35-1.61,1.33,1.33,0,0,0-.88-.86.59.59,0,0,0-.67.32c-.09.19,0,.31-.08.33s-.14-.11-.09-.38a.71.71,0,0,1,.25-.41.89.89,0,0,1,.63-.18,1.61,1.61,0,0,1,1.22,1,3.78,3.78,0,0,1,.43,1.81,2.92,2.92,0,0,1-1.64,2.83,1.22,1.22,0,0,1-1.05-.16C261.85,172.85,261.81,172.7,261.84,172.69Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.37,175a4.82,4.82,0,0,1,.13,1.17,1.78,1.78,0,0,1-.48,1.1,1.46,1.46,0,0,1-1.36.37,1.19,1.19,0,0,1-.82-1.07,2.19,2.19,0,0,1,.23-1.2,11.55,11.55,0,0,0,.56-1.06,3,3,0,0,0-.75,1,2.37,2.37,0,0,0-.32,1.32,1.74,1.74,0,0,0,.27.79,1.38,1.38,0,0,0,.75.54,1.73,1.73,0,0,0,1.63-.47,1.85,1.85,0,0,0,.5-1.28A1.77,1.77,0,0,0,263.37,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,163.61s0-.6-.31-1.63a6.69,6.69,0,0,0-2.47-3.6,6.59,6.59,0,0,0-6.2-.89,6.41,6.41,0,0,0-3,2.28,6.44,6.44,0,0,0,0,7.68,6.35,6.35,0,0,0,3,2.28,6.59,6.59,0,0,0,6.2-.89,6.69,6.69,0,0,0,2.47-3.6c.28-1,.26-1.63.31-1.63a1.21,1.21,0,0,1,0,.43,5.09,5.09,0,0,1-.14,1.25,6.76,6.76,0,0,1-2.44,3.84,7,7,0,0,1-9.86-1.37,7,7,0,0,1,0-8.3,6.95,6.95,0,0,1,9.86-1.37,6.75,6.75,0,0,1,2.44,3.85,5,5,0,0,1,.14,1.24A1.21,1.21,0,0,1,234,163.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.53,163.61c-.06,0,0-.6-.31-1.63a6.81,6.81,0,0,0-2.47-3.6,6.59,6.59,0,0,0-6.2-.89,6.5,6.5,0,0,0-3,10,6.33,6.33,0,0,0,3,2.28,6.59,6.59,0,0,0,6.2-.89,6.81,6.81,0,0,0,2.47-3.6c.27-1,.25-1.63.31-1.63a2.43,2.43,0,0,1,0,.43,5.21,5.21,0,0,1-.15,1.25,6.71,6.71,0,0,1-2.44,3.84,7,7,0,0,1-9.85-1.37,7,7,0,0,1,0-8.3,6.86,6.86,0,0,1,3.26-2.42,7,7,0,0,1,3.67-.28,6.84,6.84,0,0,1,2.92,1.33,6.7,6.7,0,0,1,2.44,3.85,5.09,5.09,0,0,1,.15,1.24A2.43,2.43,0,0,1,250.53,163.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.13,162.1c-.09.12-.78-.27-1.71-.22s-1.59.47-1.69.36.53-.85,1.67-.88S237.24,162,237.13,162.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.9,165.54a24.08,24.08,0,0,1-4.87-1.11,23.67,23.67,0,0,1-4.73-1.61,48.07,48.07,0,0,1,9.6,2.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.26,214.8c0-.14-7.11-14.12-7.11-14.12,7,.74,13.18,3.19,17.23,8.5a34.59,34.59,0,0,1,4.34,8c2.82,7,7.85,23.21,7.85,23.21l-20.24,10.55Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.73,203l19.37-6.49h0c2.61,4.65,5.87,8.46,11.69,8.41,6.18,0,10.28-3.5,13.29-8.41l2.87.72,18.12,4.84,2.29,34-3,31,8.54,30.29c-25.05,2.92-55,7.62-80.28,4.45l10.81-31-4.29-32.87-2.67-33.82Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,203.56h0a17.81,17.81,0,0,0-7.8,5,84,84,0,0,0-10.81,16.17c-7.18,13.38-8.93,17.69-8.93,17.69l21.78,12.14,8-17.28Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.36,230.43a4.85,4.85,0,0,1,.51,1.06,27.84,27.84,0,0,1,1.05,3A38,38,0,0,1,281.41,245,37.6,37.6,0,0,1,280,255.44a28.19,28.19,0,0,1-1,3,4.87,4.87,0,0,1-.5,1.06c-.09,0,.52-1.59,1.19-4.19a41.78,41.78,0,0,0-.05-20.72C278.89,232,278.27,230.46,278.36,230.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.21,233.7a14.9,14.9,0,0,1,2.1-4.54,15.49,15.49,0,0,1,3.08-4c.11.1-1.21,1.89-2.63,4.23S279.35,233.76,279.21,233.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.47,239.9a11.2,11.2,0,0,1-1-2.12c-.67-1.5-1.43-3.25-2.28-5.17l-2.33-5.16a12.16,12.16,0,0,1-.88-2.18,9.79,9.79,0,0,1,1.21,2c.69,1.28,1.57,3.08,2.48,5.1s1.64,3.89,2.14,5.26A10.08,10.08,0,0,1,213.47,239.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.92,
    y: 361.86,
    width: 5.88,
    height: 102.22,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.92,
    y: 349.03,
    width: 104.57,
    height: 13.59,
    rx: 6.8,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.74,360.92l14.55,28.15L326.23,408a3.25,3.25,0,0,1-.29,4.74h0a3.22,3.22,0,0,1-2.91.63c-6.46-1.75-29.94-8.75-30.85-10.18-1.43-2.27-17.66-28.93-17.66-28.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.94,412.76l-35.12-11.68.65,1.18a5.15,5.15,0,0,0,2.54,2.23c2.9,1.11,11,4,28.94,8.95a3.25,3.25,0,0,0,3-.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.94,404.08c.2,0,0-1.81,1.26-3.5s2.92-2.17,2.87-2.36-.49-.1-1.19.16a5,5,0,0,0-2.25,1.8,5.13,5.13,0,0,0-.94,2.73C312.68,403.66,312.86,404.1,312.94,404.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,406.72c.2,0,.59-1.34,1.81-2.54s2.57-1.64,2.52-1.83-1.66-.05-3,1.34S316.77,406.73,317,406.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.64,401.32c.21.06.81-2.08,2.53-4.11s3.7-3,3.6-3.22-2.31.57-4.13,2.77S306.47,401.32,306.64,401.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5,393.13c.17.13,1.35-1.35,3.31-2.52s3.81-1.55,3.78-1.75-2-.12-4.14,1.16S301.35,393.05,301.5,393.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.19,332.83s-4.31,14.75-3.42,30.18,2.11,86.93,1.65,88.12,23,4.74,23,4.74,5.93-35.89,7.12-45.09,3.85-11.28,3.56-36.2,6.24-19.7,11-27.95,6.52-16,3.85-30.2-8.44-18.69-8.44-18.69l-31,2.38-9.24,28.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.34,299.59s29.53-14.53,38-14.53,14.53,3.28,20.63,14.53,33.28,76.88,33.28,76.88l-20.63,12.19s-26.25-38.91-31.87-48.29L244.09,331s.94,13.12-5.16,17.81-22-.47-28.59-7.5-12.19-13.59-9.85-25.31S210.34,299.59,210.34,299.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.34,299.59l-.37.28c-.25.19-.61.47-1.06.88a23.16,23.16,0,0,0-3.55,4,28.19,28.19,0,0,0-3.81,7.65,27.7,27.7,0,0,0-1.31,11.4,20.94,20.94,0,0,0,1.94,6.49,31.88,31.88,0,0,0,4.1,6.21c.81,1,1.7,2,2.61,3s1.82,2,2.86,2.95a31,31,0,0,0,7.27,4.64,37.11,37.11,0,0,0,8.73,2.87,24.24,24.24,0,0,0,4.76.46,12.37,12.37,0,0,0,4.76-.88,6.24,6.24,0,0,0,2-1.34,4.9,4.9,0,0,0,.86-.9,8.15,8.15,0,0,0,.75-1,15.74,15.74,0,0,0,2-4.71,35.64,35.64,0,0,0,1-10.57l0-.87.45.74c2.71,4.45,5.39,9.1,8.36,13.73s6.07,9.33,9.24,14.14c6.36,9.6,13,19.56,19.92,29.77l-.33-.07,3.4-2,17.23-10.18-.11.3c-8.18-19.7-16-38.26-23.22-54.95-1.82-4.17-3.59-8.23-5.36-12.14s-3.48-7.71-5.44-11.2a42.54,42.54,0,0,0-3.26-4.9,24.73,24.73,0,0,0-3.9-4.07,17.68,17.68,0,0,0-4.64-2.73,19.12,19.12,0,0,0-5-1.2l-1.25-.11-1.24,0a8.18,8.18,0,0,0-1.22.06,9.81,9.81,0,0,0-1.2.14c-.78.17-1.56.3-2.32.5l-2.23.62c-2.91.91-5.61,1.88-8.11,2.86-5,1.94-9.22,3.8-12.66,5.32s-6.07,2.76-7.86,3.6l-2,.95-.69.31s.22-.13.67-.35l2-1c1.78-.86,4.41-2.11,7.83-3.67s7.64-3.43,12.64-5.4c2.5-1,5.2-2,8.12-2.9l2.24-.63c.76-.21,1.55-.34,2.34-.52a10.06,10.06,0,0,1,1.23-.14,7.31,7.31,0,0,1,1.24-.07l1.26,0,1.27.1a19.41,19.41,0,0,1,5.1,1.21A17.77,17.77,0,0,1,261,289a24.25,24.25,0,0,1,4,4.12,39,39,0,0,1,3.3,4.94c2,3.51,3.7,7.31,5.49,11.22s3.56,8,5.38,12.13c7.26,16.69,15.08,35.24,23.28,54.95l.08.19-.19.11-17.22,10.18-3.4,2-.2.12-.13-.19c-6.88-10.22-13.55-20.18-19.91-29.79-3.17-4.8-6.27-9.51-9.24-14.15s-5.64-9.29-8.34-13.75l.41-.13a36,36,0,0,1-1,10.71,16.29,16.29,0,0,1-2.05,4.83,8.74,8.74,0,0,1-.77,1,6.17,6.17,0,0,1-.9.94,6.67,6.67,0,0,1-2.16,1.41,13,13,0,0,1-4.92.9,24.8,24.8,0,0,1-4.83-.47,37.75,37.75,0,0,1-8.82-2.92,31.6,31.6,0,0,1-7.34-4.72,40.35,40.35,0,0,1-2.88-3c-.91-1-1.8-2-2.61-3a31.62,31.62,0,0,1-4.12-6.29,21.07,21.07,0,0,1-1.93-6.58,29,29,0,0,1,5.27-19.17,22.56,22.56,0,0,1,3.61-4A10.81,10.81,0,0,1,210.34,299.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,306.18a8.17,8.17,0,0,0-2,3.21,10,10,0,0,0-.41,4.11,27.69,27.69,0,0,0,1.08,5,70.48,70.48,0,0,0,3.2,8.82l1.17,2.6a4.81,4.81,0,0,1,.4,1,4.62,4.62,0,0,1-.57-.89c-.34-.59-.8-1.45-1.32-2.54a57,57,0,0,1-3.36-8.84,25.22,25.22,0,0,1-1-5.12,9.87,9.87,0,0,1,.53-4.25,6.77,6.77,0,0,1,1.53-2.46A2.69,2.69,0,0,1,241,306.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.57,427l-1.4,31.52,6.07,25.24a3.22,3.22,0,0,1-2.6,3.94h0a3.2,3.2,0,0,1-2.82-.89c-4.71-4.72-21.49-22.4-21.56-24.09-.12-2.68-.89-33.72-.89-33.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.64,487.67l-24.5-27.49,0,1.34a5.06,5.06,0,0,0,1.08,3.17c2,2.4,7.49,8.9,20.54,22.09a3.23,3.23,0,0,0,2.91.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.73,473.74c.18.09.93-1.55,2.82-2.4s3.6-.42,3.65-.61-.37-.33-1.1-.45a4.93,4.93,0,0,0-2.84.44,5,5,0,0,0-2.16,1.88C262.72,473.25,262.66,473.71,262.73,473.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.89,478c.15.14,1.18-.86,2.82-1.3s3-.13,3.09-.33-1.41-.86-3.27-.33S264.73,477.92,264.89,478Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.67,468.23c.14.16,1.73-1.39,4.22-2.29s4.69-.78,4.7-1-2.28-.65-4.94.34S258.52,468.14,258.67,468.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3,458.62c.08.19,1.83-.5,4.1-.53s4.06.55,4.13.35-1.7-1.11-4.14-1.05S258.2,458.47,258.3,458.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.33,
    y: 361.86,
    width: 5.88,
    height: 102.22,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.91,264.53a1.41,1.41,0,0,0-.41-.47l-2.44-2-1.23,4.13a2.76,2.76,0,0,0,2.07.47,2.81,2.81,0,0,0,1.79-1.13A1.08,1.08,0,0,0,254.91,264.53Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.57,244.27l29.11,25.24,2.71,1.17,1.5.71-.73-1.25-1.48-2.53-29.46-25.24a1.26,1.26,0,0,0-1.71.06h0A1.26,1.26,0,0,0,224.57,244.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.61,259l2.22.32s11.31-4.63,12.94-4.9c1.26-.21,7.34,1,10,1.56a2.35,2.35,0,0,1,1.9,2.28v.05a2.32,2.32,0,0,1-1.41,2.05h0a2.12,2.12,0,0,1,1.34,3c-.69,1.79-3.08,1.59-3.08,1.59l-4,.22s1,.27,2.56.57a7.29,7.29,0,0,1,2.09.61s2.48,2.21.2,3.25a4.84,4.84,0,0,1-2.41.51s.78,2.45-1.06,2.94-14.09,0-14.09,0a7.74,7.74,0,0,0-2.51-.51l-3.45-.12Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.1,260.36a23.7,23.7,0,0,1-3.15-.08,24,24,0,0,1-3.14-.28,24.65,24.65,0,0,1,3.15.07A22.91,22.91,0,0,1,251.1,260.36Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.12,272s-.18,0-.39-.23a1.53,1.53,0,0,1-.45-1,1.57,1.57,0,0,1,.31-1c.17-.23.33-.31.35-.29s-.1.15-.23.37a1.72,1.72,0,0,0-.22.94,1.69,1.69,0,0,0,.36.9C239,271.91,239.14,272,239.12,272Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.79,267.89s-.21,0-.49-.16a1.48,1.48,0,0,1-.33-2.25c.22-.25.42-.32.43-.3s-.14.14-.31.39a1.56,1.56,0,0,0-.27,1.08,1.61,1.61,0,0,0,.56,1C238.62,267.8,238.8,267.86,238.79,267.89Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.55,263.06s-.21-.09-.42-.38a1.91,1.91,0,0,1-.33-1.35,1.93,1.93,0,0,1,.68-1.21c.29-.22.51-.27.52-.25s-.18.13-.42.36a2.09,2.09,0,0,0-.57,1.13,2,2,0,0,0,.24,1.24C238.42,262.89,238.58,263,238.55,263.06Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.8,256.82s-.12-.05-.2-.21a1,1,0,0,1-.06-.67.94.94,0,0,1,.37-.57c.14-.1.25-.11.26-.09s-.32.25-.43.71A1.86,1.86,0,0,0,239.8,256.82Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.9,265.11a6.71,6.71,0,0,1-1.71.13,7.52,7.52,0,0,1-1.71-.07,7,7,0,0,1,1.71-.14A7.17,7.17,0,0,1,245.9,265.11Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.93,270.15a24.2,24.2,0,0,1-3.11-.45,22.8,22.8,0,0,1-3.08-.65,22,22,0,0,1,3.11.45A22.8,22.8,0,0,1,247.93,270.15Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.37,272.55h.17l.48,0a7.41,7.41,0,0,1,1.88.42h0c1.61,0,4,.12,7,.16,1.49,0,3.14,0,4.92,0,.44,0,.89,0,1.35-.08a2.69,2.69,0,0,0,1.29-.33,1.52,1.52,0,0,0,.63-1.15,3.48,3.48,0,0,0-.14-1.43l0-.16h.17a4.52,4.52,0,0,0,1.49-.19,3.82,3.82,0,0,0,1.39-.67,1.14,1.14,0,0,0,.2-1.39,4,4,0,0,0-1-1.31h0a10.62,10.62,0,0,0-2.22-.62l-2.4-.54-.91-.2.93-.05,4-.22h0a3.8,3.8,0,0,0,1.94-.39,2.4,2.4,0,0,0,1.22-2.16,2,2,0,0,0-1.46-1.82l-.34-.11.32-.13a2.24,2.24,0,0,0,1.33-1.92,2.18,2.18,0,0,0-1.12-2,3.3,3.3,0,0,0-1.14-.35l-1.19-.25-2.34-.45c-1.52-.28-3-.54-4.42-.71-.35,0-.7-.08-1.05-.09a2.75,2.75,0,0,0-.5,0l-.49.11c-.65.2-1.27.42-1.88.63-4.85,1.78-8.53,3.28-10.59,4.09h0l-1.66-.26-.42-.07-.13,0h.13l.42.05,1.68.21h0c2.05-.85,5.71-2.39,10.56-4.2.61-.22,1.23-.44,1.89-.64a4.37,4.37,0,0,1,.52-.12,3.25,3.25,0,0,1,.54,0,9.81,9.81,0,0,1,1.07.08c1.43.16,2.91.42,4.44.7l2.33.44,1.2.25a3.67,3.67,0,0,1,1.21.37,2.41,2.41,0,0,1,1.25,2.2,2.45,2.45,0,0,1-1.48,2.14v-.24a2.57,2.57,0,0,1,1.17.75,1.94,1.94,0,0,1,.48,1.32,3.16,3.16,0,0,1-.34,1.38,2.37,2.37,0,0,1-1,1,4.06,4.06,0,0,1-2.08.42h0l-4,.21,0-.25,2.39.54a10.25,10.25,0,0,1,2.3.66h0a4.46,4.46,0,0,1,1,1.41,1.48,1.48,0,0,1,0,1.31,1.58,1.58,0,0,1-.29.34,3.87,3.87,0,0,1-1.48.73,4.75,4.75,0,0,1-1.59.19l.12-.15a4,4,0,0,1,.15,1.53,1.78,1.78,0,0,1-.74,1.3,2.83,2.83,0,0,1-1.39.36c-.47.05-.92.05-1.37.07-1.78,0-3.43,0-4.93,0-3-.06-5.37-.16-7-.24h0a7.81,7.81,0,0,0-1.84-.45l-.48-.07Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.84,272.39s-40,2.35-43.59.5-7.87-7.47-5-15.27,6.06-14.13,6.06-14.13l9.14,4.91,9.51,5.49-1.67,2.75,26.06,2.61Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.3,256.64s-.73-.24-1.93-.58a37.87,37.87,0,0,0-4.74-1,43,43,0,0,0-4.83-.45c-1.24-.05-2,0-2-.07a3.24,3.24,0,0,1,.54-.07c.35,0,.86-.05,1.48-.05a33.13,33.13,0,0,1,4.87.39,29.79,29.79,0,0,1,4.76,1.1c.59.2,1.06.38,1.38.52A2.28,2.28,0,0,1,203.3,256.64Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.81,232.94l4.46,17.84,10-9.69,10.46,5.84L305,268c-3.38,4.82-8.14,6.72-11.88,5.77a11.83,11.83,0,0,1-2.17-.82A16.55,16.55,0,0,1,282,260L279,236.88Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.31,263.16a4.88,4.88,0,0,0,.24-.68c.14-.45.35-1.09.64-1.87s.66-1.7,1.12-2.7,1-2.07,1.68-3.16,1.34-2.09,2-3,1.29-1.65,1.84-2.27,1-1.12,1.34-1.45a4.11,4.11,0,0,0,.49-.53,4.87,4.87,0,0,0-.54.48c-.35.31-.83.79-1.4,1.4s-1.21,1.38-1.89,2.25a34.47,34.47,0,0,0-2,3,31.89,31.89,0,0,0-1.67,3.19c-.46,1-.82,1.94-1.09,2.73s-.47,1.44-.58,1.89A5.22,5.22,0,0,0,291.31,263.16Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.38,216.7s-26.06,23-31.24,27.23a54.26,54.26,0,0,1-7.55,4.52l7.13,1.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.12 213.62 341.98 215.02 342.53 219.17 301.96 256.05 267.09 253.76 264.28 250.53 303.12 213.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.84,219.17a7,7,0,0,1-.74,0H340l-7.95-.05-26.88-.33.18-.07-5.07,4.73L277.09,245l-7,6.46c-.82.74-1.46,1.32-1.94,1.74l-.51.45c-.12.09-.18.14-.19.13l.15-.17.48-.48,1.87-1.81,6.94-6.59,23-21.6,5.07-4.73.07-.07h.11l26.88.51L340,219l2.14.08A3.52,3.52,0,0,1,342.84,219.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,216a3.4,3.4,0,0,1-.76,0l-2.16,0-8.06-.2-27.23-.88.19-.07L298.67,220c-9.11,8.71-17.55,16.37-23.73,21.84-3.1,2.73-5.62,4.92-7.38,6.42l-2,1.71-.53.44c-.13.09-.19.14-.2.13a1.11,1.11,0,0,1,.16-.17l.5-.48c.49-.43,1.14-1,2-1.78l7.26-6.54c6.12-5.54,14.52-13.24,23.62-21.94l5.32-5.11.08-.08h.11l27.23,1.05,8,.36,2.17.12A5.63,5.63,0,0,1,342,216Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,251.89l.16-.17.48-.48,1.91-1.81,7.06-6.56,23.43-21.51,5.51-5,.08-.07h.1l26.75.85,7.9.3,2.12.11a3.86,3.86,0,0,1,.74.07,6.08,6.08,0,0,1-.74,0h-2.13l-7.9-.15-26.75-.68.18-.07-5.51,5-23.53,21.4-7.18,6.44c-.83.73-1.48,1.31-2,1.73l-.52.45C265.84,251.85,265.78,251.9,265.77,251.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.67,230.08a1.8,1.8,0,0,1,2.1-1.61c.56.09,1.3.23,2.19.44,2.32.53,8.85,4.81,8.87,6.22a3,3,0,0,1-1.11,2.71s1.14,2,.45,3.4c-.59,1.22-2.68,1.4-2.68,1.4s1.29,2-.43,3c-.6.37-1.79,1.07-2.08,1.32a4.81,4.81,0,0,1-.56,1,4.14,4.14,0,0,1-3.2,1.35l-.4,0a3,3,0,0,1-2-.86c-2.46-2.42-9.39-9.4-9.34-11.09,0,0-1.32-1.32-.6-2.45s2.85-.33,2.85-.33a1.8,1.8,0,0,1-.29-2.13c.66-1.19,4.53-.6,6.26-.15,1.38.36,5.22,1.48,5.22,1.48s-5-2.43-5.19-3.36A2,2,0,0,1,316.67,230.08Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.45,237.38a3.49,3.49,0,0,0,.49.38c.31.24.79.57,1.38,1,1.19.79,2.88,1.8,4.79,2.83s3.69,1.88,5,2.47l1.54.69a2.47,2.47,0,0,0,.57.22,3.74,3.74,0,0,0-.54-.29l-1.51-.74c-1.28-.63-3-1.5-4.95-2.53s-3.6-2-4.8-2.76c-.61-.38-1.09-.69-1.42-.91A3.15,3.15,0,0,0,308.45,237.38Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.47,234.52a2.68,2.68,0,0,0,.55.2c.36.12.88.28,1.52.51,1.27.45,3,1.16,4.86,2,.94.43,1.84.82,2.64,1.22s1.5.78,2.08,1.12,1,.63,1.36.84a3,3,0,0,0,.5.3.59.59,0,0,0-.11-.1l-.35-.26a15,15,0,0,0-1.33-.89c-.58-.36-1.27-.77-2.07-1.17s-1.7-.81-2.64-1.24a50.45,50.45,0,0,0-4.9-2c-.64-.22-1.17-.36-1.54-.46A3.68,3.68,0,0,0,310.47,234.52Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.89,233.8a4,4,0,0,0,.78.56c.5.31,1.21.71,2,1.16s1.48.86,2,1.18a7.49,7.49,0,0,0,.82.49,3.8,3.8,0,0,0-.74-.61c-.48-.34-1.17-.79-1.95-1.23s-1.5-.83-2-1.11A5.86,5.86,0,0,0,321.89,233.8Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.52,240.73a3,3,0,0,0,.31.46c.21.28.53.68.94,1.16.82,1,2,2.22,3.32,3.64.33.35.63.71,1,1s.65.62,1,.89a7.26,7.26,0,0,0,1.92,1.13,4.29,4.29,0,0,0,1.47.32,1.72,1.72,0,0,0,.41,0c.09,0,.14,0,.14,0l-.55,0a5,5,0,0,1-1.42-.38,7.31,7.31,0,0,1-1.85-1.14,11.16,11.16,0,0,1-.95-.89c-.32-.32-.62-.68-.94-1-1.3-1.43-2.53-2.66-3.37-3.6-.42-.47-.75-.85-1-1.12A4.5,4.5,0,0,0,310.52,240.73Z",
    style: {
      fill: "#ff9a6c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheets-2--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "461.65 383.14 461.65 379.46 379.75 379.62 375.02 379.62 375.02 383.19 379.75 383.19 379.75 405.21 468.2 405.21 468.2 383.14 461.65 383.14",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.57 405.63 441.57 379.46 461.65 379.46 461.65 382.23 468.2 382.23 468.2 405.21 441.57 405.63",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.65,379.46c0,.14-19.23.26-42.94.26s-42.95-.12-42.95-.26,19.23-.26,42.95-.26S461.65,379.32,461.65,379.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.54,391c0,.14-19.58.26-43.73.26s-43.73-.12-43.73-.26,19.58-.26,43.73-.26S467.54,390.88,467.54,391Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.2,398.92c0,.14-19.73.26-44.06.26s-44.06-.12-44.06-.26,19.73-.26,44.06-.26S468.2,398.77,468.2,398.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.76,383.14c0-.15,19.23-.26,42.94-.26s42.95.11,42.95.26-19.23.26-42.95.26S375.76,383.28,375.76,383.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.77,405.49V438.4H371V442h4.74v22h88.44V444h-6.55v-4.36h6.55V433h2.92v-3h-3.46V405.49Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.73 405.59 440.73 463.99 464.21 464.08 464.21 443.59 457.66 443.59 457.66 439.59 464.21 439.73 464.21 433.18 467.18 433.18 467.13 429.8 463.67 429.7 463.67 405.49 440.73 405.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.56,438.24c0,.14-20.55.26-45.89.26s-45.89-.12-45.89-.26,20.54-.26,45.89-.26S463.56,438.1,463.56,438.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.66,441.92c0,.14-19.23.26-42.94.26s-42.94-.12-42.94-.26,19.22-.26,42.94-.26S457.66,441.77,457.66,441.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.56,449.81c0,.14-19.58.26-43.73.26s-43.73-.12-43.73-.26,19.57-.26,43.73-.26S463.56,449.66,463.56,449.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.13,429.66c0,.14-20.38.26-45.52.26s-45.51-.12-45.51-.26,20.37-.26,45.51-.26S467.13,429.51,467.13,429.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.56,409.5c0,.15-19.58.26-43.73.26s-43.73-.11-43.73-.26,19.57-.26,43.73-.26S463.56,409.36,463.56,409.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.67,419.76c0,.15-19.53.26-43.62.26s-43.62-.11-43.62-.26,19.52-.26,43.62-.26S463.67,419.62,463.67,419.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.21,457.7c0,.14-19.72.26-44,.26s-44.06-.12-44.06-.26,19.72-.26,44.06-.26S464.21,457.55,464.21,457.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.72,
    y: 419.76,
    width: 3.79,
    height: 4.79,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.64,
    y: 429.72,
    width: 7.23,
    height: 4.79,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.67,405.39c0,.15-19.68.26-43.95.26s-44-.11-44-.26,19.67-.26,44-.26S463.67,405.25,463.67,405.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.23,304.39V334.7h-4.36V338h4.36v20.29H460.7V339.82h-6v-4h6v-6h2.69V327H460.2V304.39Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.78 304.48 420.78 358.28 460.7 358.36 460.7 339.48 454.67 339.48 454.67 335.8 460.7 335.93 460.7 329.89 463.44 329.9 463.39 326.78 460.2 326.69 460.2 304.39 420.78 304.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.1,334.56c0,.14-18.93.26-42.27.26s-42.28-.12-42.28-.26,18.92-.26,42.28-.26S460.1,334.41,460.1,334.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.67,337.94c0,.15-17.71.26-39.56.26s-39.56-.11-39.56-.26,17.71-.26,39.56-.26S454.67,337.8,454.67,337.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.1,345.21c0,.15-18,.26-40.28.26s-40.29-.11-40.29-.26,18-.26,40.29-.26S460.1,345.07,460.1,345.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.39,326.65c0,.14-18.78.26-41.93.26s-41.93-.12-41.93-.26,18.77-.26,41.93-.26S463.39,326.51,463.39,326.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.1,308.09c0,.14-18,.26-40.28.26s-40.29-.12-40.29-.26,18-.26,40.29-.26S460.1,307.94,460.1,308.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.32,314c0,.14-18,.26-40.28.26s-40.29-.12-40.29-.26,18-.26,40.29-.26S460.32,313.89,460.32,314Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.2,317.54c0,.14-18,.26-40.18.26s-40.18-.12-40.18-.26,18-.26,40.18-.26S460.2,317.39,460.2,317.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.7,352.48c0,.15-18.17.26-40.58.26s-40.59-.11-40.59-.26,18.17-.26,40.59-.26S460.7,352.34,460.7,352.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.82,
    y: 313.9,
    width: 5.31,
    height: 5.09,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.96,
    y: 326.71,
    width: 6.66,
    height: 4.41,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.89,322.46v41.68h48.47V322.46Zm15.82,7.5a2.83,2.83,0,0,1,2.48-3.08h11.87a3.15,3.15,0,0,1,0,6.16H435.19A2.83,2.83,0,0,1,432.71,330Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.8,322.46v41.68h45V322.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.55,323.06a81.91,81.91,0,0,1-.26-9.16,81.91,81.91,0,0,1,.26-9.16,79.13,79.13,0,0,1,.26,9.16A79.13,79.13,0,0,1,420.55,323.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.1,322.46a1.34,1.34,0,0,1,0-.32c0-.24,0-.55,0-.93,0-.86,0-2.07-.05-3.6,0-3.16-.05-7.67-.09-13.22l.19.19-40.43.07-40.44-.07.18-.19c0,5.56-.06,10.06-.08,13.22,0,1.53,0,2.74-.05,3.6q0,.57,0,.93a2,2,0,0,1,0,.32,1.34,1.34,0,0,1,0-.32q0-.36,0-.93c0-.86,0-2.07-.05-3.6,0-3.16-.05-7.66-.08-13.22v-.19h.19l40.44-.07,40.43.07h.19v.19c0,5.55-.07,10.06-.09,13.22,0,1.53,0,2.74-.05,3.6,0,.38,0,.69,0,.93A1.34,1.34,0,0,1,460.1,322.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.57,
    y: 366.07,
    width: 28.47,
    height: 11.22,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.38,
    y: 364.14,
    width: 89.4,
    height: 2.35,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.79,
    y: 376.78,
    width: 88.99,
    height: 2.35,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.03 364.7 404.17 378.69 463.78 378.69 463.78 364.7 404.03 364.7",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 415.3,
    cy: 371.68,
    rx: 3.22,
    ry: 3.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.3,375.66a4,4,0,1,1,3.72-4A3.86,3.86,0,0,1,415.3,375.66Zm0-7a3,3,0,1,0,2.72,3A2.86,2.86,0,0,0,415.3,368.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.89,374.54c0,.14-5.85.26-13.06.26s-13.06-.12-13.06-.26,5.84-.26,13.06-.26S401.89,374.39,401.89,374.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.89,372.58c0,.15-5.85.26-13.06.26s-13.06-.11-13.06-.26,5.84-.26,13.06-.26S401.89,372.44,401.89,372.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.89,370.63c0,.14-5.85.26-13.06.26s-13.06-.12-13.06-.26,5.84-.26,13.06-.26S401.89,370.48,401.89,370.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.89,368.67c0,.15-5.85.26-13.06.26s-13.06-.11-13.06-.26,5.84-.26,13.06-.26S401.89,368.53,401.89,368.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.31,
    y: 367.68,
    width: 26.86,
    height: 7.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.49,374.4a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,374.4a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.59,374.4a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.15,374.4a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.7,374.4a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.25,374.4a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.44,379.1a51,51,0,0,1-.27-7.42,51.24,51.24,0,0,1,.27-7.43,106.15,106.15,0,0,1,0,14.85Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.98,
    y: 283.61,
    width: 10.99,
    height: 179.55,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.23,
    y: 283.61,
    width: 10.99,
    height: 180.39,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.22,
    y: 273.22,
    width: 381.56,
    height: 11.84,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.29,
    y: 270.16,
    width: 54.02,
    height: 3.06,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mug--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381,156.26H404.4l-1.75,12.85s-1.53,6.34-5.08,6.34H387.44a10.85,10.85,0,0,1-4.93-6.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,156.26a2.77,2.77,0,0,1,.07.4c0,.29.09.67.16,1.15.14,1,.33,2.47.58,4.28l.86,6.56a10.55,10.55,0,0,0,4.83,6.64l-.08,0,8.1,0c.7,0,1.44,0,2.15,0a3,3,0,0,0,1.88-.79,9.32,9.32,0,0,0,2.35-3.72,16.65,16.65,0,0,0,.53-1.65v0c.62-4.54,1.22-8.87,1.76-12.86l.19.21-16.78-.09-4.84,0-1.3,0-.46,0a1.75,1.75,0,0,1,.42,0l1.26,0,4.79,0,16.91-.1h.21l0,.21c-.54,4-1.12,8.32-1.73,12.86h0a15.44,15.44,0,0,1-.55,1.71,9.49,9.49,0,0,1-2.47,3.87,3.38,3.38,0,0,1-2.11.89c-.75,0-1.46,0-2.17,0h-8.16l0,0a10.76,10.76,0,0,1-5-6.9c-.34-2.57-.57-4.83-.78-6.67s-.35-3.26-.46-4.29l-.12-1.11A2.08,2.08,0,0,1,381,156.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.64,162.89l.34-.08s.22-.05,0,0,.06,0,.11,0a6.45,6.45,0,0,1,.76,0c-.25,0,0,0,.09,0a3.34,3.34,0,0,1,.4.1l.33.11c.15,0,0,0-.06,0l.21.1a5.32,5.32,0,0,1,.65.39c.13.09,0,0-.05,0l.13.12a4,4,0,0,1,.29.29c.07.07.22.27.08.07l.22.35c.07.1.11.21.17.31s0,0,0-.06a2.09,2.09,0,0,1,.08.23,2.62,2.62,0,0,1,.11.4c0,.05.08.39.05.22s0,.18,0,.23V166a1.94,1.94,0,0,1,0,.24s0,.22,0,0,0,.17-.05.23-.06.23-.1.34-.16.42,0,.17a5.63,5.63,0,0,1-.38.68,1.3,1.3,0,0,0-.1.15s.14-.16,0-.06-.21.24-.33.34-.3.24-.17.15l-.2.13a3.07,3.07,0,0,1-.31.17l-.15.08c.17-.09.08,0,0,0s-.52.14-.79.21.06,0,.08,0l-.23,0h-.65s-.28,0-.1,0,0,0,0,0l-.23,0-.45-.14s-.2-.08-.05,0-.15-.08-.15-.08a1.41,1.41,0,1,0-1.42,2.43,6,6,0,0,0,7.9-2.16,6.25,6.25,0,0,0,.67-4.44,5.74,5.74,0,0,0-2.57-3.57,6.06,6.06,0,0,0-4.8-.73,1.43,1.43,0,0,0-1,1.73,1.45,1.45,0,0,0,1.74,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.64,162.89a1,1,0,0,1-.48.08,1.45,1.45,0,0,1-1.19-.72,1.48,1.48,0,0,1,.54-2,3.84,3.84,0,0,1,1.36-.35,7,7,0,0,1,1.57,0,6.22,6.22,0,0,1,3.21,1.52,5.76,5.76,0,0,1,1.89,3.61,6.27,6.27,0,0,1-1,4.37,5.94,5.94,0,0,1-4.13,2.47,6.19,6.19,0,0,1-2.19-.07,7.3,7.3,0,0,1-1-.3l-.48-.22a1.48,1.48,0,0,1-.48-.35,1.71,1.71,0,0,1,0-2.13,1.68,1.68,0,0,1,2-.33l-.28.17a.2.2,0,0,1,.17-.19.2.2,0,0,1,.11,0h.06l.08,0,0,0h0l0,0c0-.1.15.3-.08.33a.15.15,0,0,1-.08,0h0l-.08,0h0s0,0-.05-.05c-.1-.41.29-.29.17-.3h.08l.07,0,.14,0a3.19,3.19,0,0,0,.59.15h0l.1.06s.06,0,0,.16-.15.15-.16.15h-.18l-.06,0,0,0s-.11-.05-.05-.23.14-.08.15-.09h.46a5.82,5.82,0,0,0,.59,0l0,.35-.06,0h-.1a.28.28,0,0,1-.12-.05.18.18,0,0,1,0-.2c0-.07,0,0,0-.06s.07,0,.08-.05h0l.15,0,.31-.08.3-.08.14-.05h0l0,0c-.08-.07,0,.35.1.3s.06,0,.06,0h0l-.06,0-.16-.31c.14-.06.27-.14.4-.21l.19-.11,0,0h.06l.1,0a.18.18,0,0,1,.1.06c.08.07,0,.23,0,.23l0,0-.05,0h0a.15.15,0,0,1-.11,0,.16.16,0,0,1-.13-.1c-.06-.1.07-.23,0-.19h0l0,0c.12-.1.21-.18.32-.29l.15-.16,0,0,0,0,0,0h0s.17,0,.21.11,0,.09,0,.11h0l0,0h0L406,168l-.27-.19c.19-.26.32-.54.47-.79l.29.13,0,.05v0l0,0h0s0,0-.12.05a.17.17,0,0,1-.15-.18v0l.05-.11a1.39,1.39,0,0,0,.06-.19c0-.14.08-.26.11-.4l0-.11v0h0s0,0,.06-.08a.16.16,0,0,1,.15,0s.05,0,.05.05,0,.11,0,.11h0v.1h0v0c.1.12-.43.06-.29,0v-.09s0-.06,0-.09a2.71,2.71,0,0,0,0-.4,2.41,2.41,0,0,0,0-.38v-.11a.17.17,0,0,1,.07-.12.14.14,0,0,1,.15,0s0,0,.05.05l0,0v.07h0v0s0,0,0,.05a.21.21,0,0,1-.08.06.16.16,0,0,1-.17-.07c0-.13,0-.15-.05-.23a5.27,5.27,0,0,0-.19-.68l.24-.09,0,0v.05h0v0h0v0a.13.13,0,0,1-.1.14c-.1,0-.1,0-.11,0l0,0-.07-.12-.11-.22-.24-.38.2-.14,0,.06,0,0h0a.14.14,0,0,1,0,.12c-.13.16-.22,0-.2,0h0l-.08-.1s-.1-.1-.15-.15-.19-.2-.3-.3l.15-.16.06,0,0,0h0s0,0,0,0c-.25.34-.1.08-.15.16h0l-.14-.09-.25-.16a3.77,3.77,0,0,0-.47-.27l.08-.17.08,0h0l0,0s.05.11,0,.14,0,0-.05,0h-.08l-.17-.06a2.22,2.22,0,0,0-.31-.1,1.74,1.74,0,0,0-.29-.07l-.13,0h0c.06,0-.12.07,0-.15h.12v.14l-.68,0H403s0,0,0-.07l0,0h0l.12,0h0s0,0,.05,0,0,0,0,0H403a1.83,1.83,0,0,1-.38.06,1.3,1.3,0,0,1,.37-.13h.07s0,0,0,0,.05,0,0,0h0l-.11,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h.93v.14h-.12s0,0,0,0c.12-.22-.07-.13,0-.15H404l.3.07a1.92,1.92,0,0,1,.32.09l.17.05h0c-.06.25-.07.15-.08.17l-.09,0,.08-.17a3.45,3.45,0,0,1,.49.27l.27.15.14.09h0l0,.08s0-.07,0,0,0,0,0,0,0,0,0,0l0,0-.08-.06.15-.16.32.29c0,.06.11.11.17.17l.07.09h0s-.05,0-.07,0,0,0,0,0,0,0,0,0,0,0,0,.05l0,0h0l0,0,0-.05.2-.14.25.39.12.22s.07.06,0,.11l-.07.06-.09,0,0,0h0l0,0,0-.07.24-.09a6.1,6.1,0,0,1,.23.72v.16h-.08s-.05,0-.06,0,0,0,0,0a.09.09,0,0,0-.07,0l-.06,0h0v0h.08s.05,0,.05,0,.06,0,.06,0h.09v.07a2.61,2.61,0,0,1,0,.4,3,3,0,0,1,0,.42.41.41,0,0,1,0,.11v0h0s0,0-.11,0l-.18,0h0v-.07h0s0,0,0,0,0,0,.05,0,.1,0,.09,0l.15,0v0l0,.1c0,.14-.07.29-.1.43s0,.15-.07.21l0,.1c-.4-.16-.25-.12-.27-.15l0,0,.29.13c-.16.27-.29.57-.49.85l-.27-.19.08-.09.06,0s.06,0,.08.08,0,0,0,.05l0,.06h0l0,0-.16.16a2.46,2.46,0,0,1-.33.31h0l0,0c-.07-.06-.08-.11-.1-.1s0,0,0-.05l-.06-.09h0l0,0h0s.06.06,0,.07,0,.09.05.09,0-.05,0,0a.1.1,0,0,0,.07.1l0,0h0l-.05,0-.2.13-.41.22-.16-.31.07,0h.13c.14,0,.17.37.09.29l-.05,0,0,0-.16.06-.32.09-.31.08-.16,0s0,.08-.06-.15c0,0,0-.21,0-.19H404l0,.35a4.22,4.22,0,0,1-.62,0,1.85,1.85,0,0,1-.33,0H403s0,0,0,0a.92.92,0,0,1,0-.17.88.88,0,0,0,0-.16h.12v0a.41.41,0,0,1,0,.09s0,0,0,.06,0,0,0,0,0,.05,0,.08a.24.24,0,0,1,0,.09h0a4.15,4.15,0,0,1-.63-.16l-.16-.05-.09,0h0l0-.07a.69.69,0,0,0,0-.1c.14-.27.07-.15.09-.18h0l.07,0h0s0,0,0,.05,0,.12,0,.14l-.09.15s0,0,0,0h0l-.07,0H402s0,0,.11,0a.19.19,0,0,0,.13-.1.06.06,0,0,0,0,0s0,0-.14,0l-.13.17a1.28,1.28,0,0,0-1.54.24,1.32,1.32,0,0,0,0,1.62,2.39,2.39,0,0,0,.81.46,8.25,8.25,0,0,0,1,.28,5.93,5.93,0,0,0,2.06.06,5.59,5.59,0,0,0,3.86-2.29,5.94,5.94,0,0,0,1-4.11,5.38,5.38,0,0,0-1.75-3.4,5.85,5.85,0,0,0-3-1.49,5.19,5.19,0,0,0-2.77.23,1.38,1.38,0,0,0-.65.86,1.25,1.25,0,0,0,.14.9,1.39,1.39,0,0,0,1.05.72A3,3,0,0,0,402.64,162.89Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--documents-1--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.11,
    y: 218.7,
    width: 28.47,
    height: 11.22,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.93,
    y: 216.78,
    width: 89.4,
    height: 2.35,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.34,
    y: 229.42,
    width: 88.99,
    height: 2.35,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.58 217.34 373.71 231.32 433.33 231.32 433.33 217.34 373.58 217.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.07,224.31a3.23,3.23,0,1,1-3.23-3.48A3.37,3.37,0,0,1,388.07,224.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.84,228.29a4,4,0,1,1,3.73-4A3.86,3.86,0,0,1,384.84,228.29Zm0-7a3,3,0,1,0,2.73,3A2.86,2.86,0,0,0,384.84,221.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.44,227.17c0,.14-5.85.26-13.06.26s-13.07-.12-13.07-.26,5.85-.26,13.07-.26S371.44,227,371.44,227.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.44,225.21c0,.15-5.85.26-13.06.26s-13.07-.11-13.07-.26,5.85-.26,13.07-.26S371.44,225.07,371.44,225.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.44,223.26c0,.14-5.85.26-13.06.26s-13.07-.12-13.07-.26,5.85-.26,13.07-.26S371.44,223.12,371.44,223.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.44,221.31c0,.14-5.85.26-13.06.26s-13.07-.12-13.07-.26,5.85-.26,13.07-.26S371.44,221.16,371.44,221.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.85,
    y: 220.31,
    width: 26.86,
    height: 7.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,227a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59,227a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.14,227a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.69,227a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.24,227a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.8,227a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,231.73a53.81,53.81,0,0,1-.26-7.42,54,54,0,0,1,.26-7.43,54,54,0,0,1,.26,7.43A53.81,53.81,0,0,1,374,231.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.96 250.26 427.96 246.58 351.01 246.74 346.56 246.74 346.56 250.31 351.01 250.31 351.01 272.34 434.12 272.34 434.12 250.26 427.96 250.26",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.09 272.34 409.09 246.58 427.96 246.58 427.96 250.26 434.12 250.26 434.12 272.34 409.09 272.34",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,246.58c0,.15-18.07.26-40.35.26s-40.35-.11-40.35-.26,18.06-.26,40.35-.26S428,246.44,428,246.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.5,258.15c0,.15-18.4.26-41.09.26s-41.09-.11-41.09-.26,18.39-.26,41.09-.26S433.5,258,433.5,258.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.12,266c0,.15-18.54.26-41.4.26s-41.4-.11-41.4-.26,18.53-.26,41.4-.26S434.12,265.9,434.12,266Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.26,250.26c0-.14,18.07-.26,40.35-.26s40.35.12,40.35.26-18.06.26-40.35.26S347.26,250.41,347.26,250.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.3 179.45 430.3 175.79 353.89 175.95 349.47 175.95 349.47 179.5 353.89 179.5 353.89 201.37 436.41 201.37 436.41 179.45 430.3 179.45",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.56 201.37 411.56 175.79 430.3 175.79 430.3 179.45 436.41 179.45 436.41 201.37 411.56 201.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.3,175.79c0,.15-17.94.27-40.07.27s-40.06-.12-40.06-.27,17.93-.26,40.06-.26S430.3,175.65,430.3,175.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.8,187.28c0,.15-18.27.26-40.8.26s-40.8-.11-40.8-.26S372.46,187,395,187,435.8,187.14,435.8,187.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.41,195.12c0,.14-18.41.26-41.11.26s-41.1-.12-41.1-.26,18.4-.26,41.1-.26S436.41,195,436.41,195.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.17,179.45c0-.15,17.93-.26,40.06-.26s40.07.11,40.07.26-17.94.26-40.07.26S350.17,179.59,350.17,179.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.89,
    y: 233.28,
    width: 28.47,
    height: 11.22,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.71,
    y: 231.35,
    width: 89.4,
    height: 2.35,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.12,
    y: 243.99,
    width: 88.99,
    height: 2.35,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.36 231.91 377.49 245.9 437.11 245.9 437.11 231.91 377.36 231.91",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.85,238.89a3.23,3.23,0,1,1-3.22-3.48A3.36,3.36,0,0,1,391.85,238.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.63,242.87a4,4,0,1,1,3.72-4A3.87,3.87,0,0,1,388.63,242.87Zm0-7a3,3,0,1,0,2.72,3A2.87,2.87,0,0,0,388.63,235.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.22,241.74c0,.15-5.85.27-13.06.27s-13.07-.12-13.07-.27,5.85-.26,13.07-.26S375.22,241.6,375.22,241.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.22,239.79c0,.14-5.85.26-13.06.26s-13.07-.12-13.07-.26,5.85-.26,13.07-.26S375.22,239.65,375.22,239.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.22,237.84c0,.14-5.85.26-13.06.26s-13.07-.12-13.07-.26,5.85-.26,13.07-.26S375.22,237.69,375.22,237.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.22,235.88c0,.15-5.85.26-13.06.26s-13.07-.11-13.07-.26,5.85-.26,13.07-.26S375.22,235.74,375.22,235.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.63,
    y: 234.89,
    width: 26.86,
    height: 7.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.82,241.61a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.37,241.61a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.92,241.61a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.47,241.61a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,241.61a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.58,241.61a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.76,246.31a53.81,53.81,0,0,1-.26-7.42,54,54,0,0,1,.26-7.43,52.19,52.19,0,0,1,.26,7.43A52,52,0,0,1,377.76,246.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.89,
    y: 203.71,
    width: 28.47,
    height: 11.22,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.71,
    y: 201.78,
    width: 89.4,
    height: 2.35,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.12,
    y: 214.42,
    width: 88.99,
    height: 2.35,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.36 202.34 377.49 216.32 437.11 216.32 437.11 202.34 377.36 202.34",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.85,209.32a3.23,3.23,0,1,1-3.22-3.48A3.36,3.36,0,0,1,391.85,209.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.63,213.3a4,4,0,1,1,3.72-4A3.87,3.87,0,0,1,388.63,213.3Zm0-7a3,3,0,1,0,2.72,3A2.87,2.87,0,0,0,388.63,206.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.22,212.17c0,.15-5.85.26-13.06.26s-13.07-.11-13.07-.26,5.85-.26,13.07-.26S375.22,212,375.22,212.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.22,210.22c0,.14-5.85.26-13.06.26s-13.07-.12-13.07-.26,5.85-.26,13.07-.26S375.22,210.08,375.22,210.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.22,208.27c0,.14-5.85.26-13.06.26s-13.07-.12-13.07-.26,5.85-.26,13.07-.26S375.22,208.12,375.22,208.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.22,206.31c0,.15-5.85.26-13.06.26s-13.07-.11-13.07-.26,5.85-.26,13.07-.26S375.22,206.17,375.22,206.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.63,
    y: 205.31,
    width: 26.86,
    height: 7.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.82,212a17.27,17.27,0,0,1,0-6,17.27,17.27,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.37,212a17.27,17.27,0,0,1,0-6,17.27,17.27,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.92,212a17.27,17.27,0,0,1,0-6,17.27,17.27,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.47,212a17.27,17.27,0,0,1,0-6,17.27,17.27,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,212a17.27,17.27,0,0,1,0-6,17.27,17.27,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.58,212a17.27,17.27,0,0,1,0-6,17.27,17.27,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.76,216.74a53.81,53.81,0,0,1-.26-7.42,53.9,53.9,0,0,1,.26-7.43,52.08,52.08,0,0,1,.26,7.43A52,52,0,0,1,377.76,216.74Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.4,216.54h60.9c2,0,3.94,1.05,4.25,3.21l8.11,49.74h32a2,2,0,0,1,0,4.06H103.36l-7-51.92A4.33,4.33,0,0,1,100.4,216.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.4,216.54a4.85,4.85,0,0,0-1.05.17A4.1,4.1,0,0,0,97,218.6a4.53,4.53,0,0,0-.63,2.16,6.78,6.78,0,0,0,.11,1.32c.06.45.12.93.19,1.43l.93,6.82c1.4,10.27,3.41,25.07,5.87,43.2l-.1-.09,98.94,0h3.39a1.65,1.65,0,0,0,1.51-1,2,2,0,0,0-.32-2.33,1.61,1.61,0,0,0-1.1-.5H173.55l0-.11c-2.71-16.69-5.25-32.26-7.52-46.22-.14-.88-.28-1.74-.42-2.6-.07-.43-.14-.87-.22-1.28a3.44,3.44,0,0,0-.51-1.14,3.74,3.74,0,0,0-2-1.39,5,5,0,0,0-1.21-.23c-.41,0-.83,0-1.25,0h-9.65l-17.14,0-24.42,0-6.53,0h0l6.53,0,24.42,0,17.14,0h9.65c.42,0,.83,0,1.26,0a5.07,5.07,0,0,1,1.27.23,3.91,3.91,0,0,1,2.11,1.47,3.87,3.87,0,0,1,.54,1.21c.09.44.15.86.22,1.29.14.86.28,1.73.43,2.6,2.28,14,4.83,29.54,7.55,46.22l-.12-.11h32.13a1.89,1.89,0,0,1,1.28.59,2.29,2.29,0,0,1,.37,2.64,2.05,2.05,0,0,1-1,1,2,2,0,0,1-.71.14H202.3l-98.94,0h-.09v-.09c-2.43-18.14-4.41-32.94-5.78-43.21q-.51-3.85-.91-6.83c-.06-.5-.13-1-.19-1.43a6.76,6.76,0,0,1-.09-1.33,4.63,4.63,0,0,1,.65-2.19,4.08,4.08,0,0,1,2.4-1.89,2.88,2.88,0,0,1,.79-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.35,246.38a4.23,4.23,0,1,1-4.23-4.23A4.22,4.22,0,0,1,137.35,246.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.55,273c-.09,0-2.24-12.51-4.8-28s-4.54-28-4.45-28,2.24,12.51,4.8,28S170.65,273,170.55,273Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheets-1--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.76,
    y: 306.74,
    width: 28.47,
    height: 11.22,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.57,
    y: 304.82,
    width: 89.4,
    height: 2.35,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.98,
    y: 317.46,
    width: 88.99,
    height: 2.35,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.22 305.38 50.36 319.36 109.97 319.36 109.97 305.38 50.22 305.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.49,
    cy: 312.35,
    rx: 3.22,
    ry: 3.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.49,316.33a4,4,0,1,1,3.72-4A3.86,3.86,0,0,1,61.49,316.33Zm0-7a3,3,0,1,0,2.72,3A2.86,2.86,0,0,0,61.49,309.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.08,315.21c0,.14-5.85.26-13.06.26S22,315.35,22,315.21,27.8,315,35,315,48.08,315.06,48.08,315.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.08,313.25c0,.15-5.85.26-13.06.26S22,313.4,22,313.25,27.8,313,35,313,48.08,313.11,48.08,313.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.08,311.3c0,.14-5.85.26-13.06.26S22,311.44,22,311.3,27.8,311,35,311,48.08,311.16,48.08,311.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.08,309.35c0,.14-5.85.26-13.06.26S22,309.49,22,309.35s5.84-.26,13.06-.26S48.08,309.2,48.08,309.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 308.35,
    width: 26.86,
    height: 7.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.68,315.07a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.23,315.07a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.78,315.07a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.34,315.07a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.89,315.07a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.44,315.07a17.21,17.21,0,0,1,0-6,17.21,17.21,0,0,1,0,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.63,319.77a51,51,0,0,1-.27-7.42,51.24,51.24,0,0,1,.27-7.43,54,54,0,0,1,.26,7.43A53.81,53.81,0,0,1,50.63,319.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.8 323.78 107.8 320.1 22.58 320.26 17.66 320.26 17.66 323.83 22.58 323.83 22.58 345.85 114.61 345.85 114.61 323.78 107.8 323.78",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.9 345.85 86.9 320.1 107.8 320.1 107.8 322.87 114.61 322.87 114.61 345.85 86.9 345.85",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8,320.1c0,.14-20,.26-44.68.26s-44.69-.12-44.69-.26,20-.26,44.69-.26S107.8,320,107.8,320.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.93,331.67c0,.14-20.37.26-45.5.26s-45.51-.12-45.51-.26,20.37-.26,45.51-.26S113.93,331.52,113.93,331.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.62,339.56c0,.14-20.53.26-45.85.26s-45.85-.12-45.85-.26,20.53-.26,45.85-.26S114.62,339.41,114.62,339.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.43,323.78c0-.15,20-.26,44.68-.26s44.69.11,44.69.26-20,.26-44.69.26S18.43,323.92,18.43,323.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,404.63v32.9H20v3.57H25v22h92v-20h-6.82v-4.37H117v-6.55h3v-3h-3.6V404.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.55 404.72 92.55 463.13 116.99 463.21 116.99 442.72 110.17 442.72 110.17 438.72 116.99 438.86 116.99 432.31 120.08 432.31 120.02 428.93 116.42 428.83 116.42 404.63 92.55 404.72",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,437.37c0,.15-21.38.26-47.74.26s-47.76-.11-47.76-.26,21.38-.26,47.76-.26S116.3,437.23,116.3,437.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.17,441.05c0,.14-20,.26-44.68.26s-44.69-.12-44.69-.26,20-.26,44.69-.26S110.17,440.91,110.17,441.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,448.94c0,.14-20.37.26-45.5.26s-45.5-.12-45.5-.26,20.37-.26,45.5-.26S116.3,448.8,116.3,448.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,428.79c0,.14-21.21.26-47.36.26s-47.36-.12-47.36-.26,21.2-.26,47.36-.26S120,428.64,120,428.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,408.64c0,.14-20.37.26-45.5.26s-45.5-.12-45.5-.26,20.37-.26,45.5-.26S116.3,408.49,116.3,408.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.42,418.9c0,.14-20.32.26-45.39.26s-45.39-.12-45.39-.26S46,418.64,71,418.64,116.42,418.75,116.42,418.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,456.83c0,.14-20.53.26-45.85.26S25.3,457,25.3,456.83s20.52-.26,45.84-.26S117,456.69,117,456.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.36,
    y: 418.9,
    width: 3.95,
    height: 4.79,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.44,
    y: 428.85,
    width: 7.52,
    height: 4.79,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.46,345.84v32.9H16.54v3.58h4.92v22h92v-20h-6.82v-4.37h6.82v-6.54h3v-3h-3.6V345.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.06 345.93 89.06 404.34 113.5 404.43 113.5 383.93 106.68 383.93 106.68 379.93 113.5 380.07 113.5 373.52 116.59 373.53 116.53 370.14 112.93 370.04 112.93 345.84 89.06 345.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.81,378.58c0,.15-21.38.26-47.74.26s-47.76-.11-47.76-.26,21.38-.26,47.76-.26S112.81,378.44,112.81,378.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.68,382.26c0,.15-20,.26-44.68.26s-44.69-.11-44.69-.26S37.31,382,62,382,106.68,382.12,106.68,382.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.81,390.15c0,.15-20.37.26-45.5.26s-45.5-.11-45.5-.26,20.37-.26,45.5-.26S112.81,390,112.81,390.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.53,370c0,.14-21.21.26-47.36.26s-47.36-.12-47.36-.26,21.2-.26,47.36-.26S116.53,369.86,116.53,370Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.81,349.85c0,.14-20.37.26-45.5.26s-45.5-.12-45.5-.26,20.37-.26,45.5-.26S112.81,349.71,112.81,349.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.3 360.11 96.24 364.9 104.01 364.9 101.66 360.11 94.3 360.11",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.93,360.11c0,.14-20.32.26-45.39.26s-45.39-.12-45.39-.26,20.32-.26,45.39-.26S112.93,360,112.93,360.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5,398c0,.15-20.53.26-45.85.26s-45.84-.11-45.84-.26,20.52-.26,45.84-.26S113.5,397.9,113.5,398Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.85,
    y: 360.11,
    width: 3.95,
    height: 4.79,
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.42,404.53c0,.14-21.43.26-47.85.26s-47.86-.12-47.86-.26,21.43-.27,47.86-.27S116.42,404.38,116.42,404.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,345.84c0,.14-20.68.26-46.19.26s-46.2-.12-46.2-.26,20.68-.26,46.2-.26S113.1,345.69,113.1,345.84Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.94,413.18,133.59,438a1.68,1.68,0,0,1-1.66,1.59l-44.69.33a1.68,1.68,0,0,1-1.69-1.67l-.14-19.33a1.67,1.67,0,0,1,1.67-1.69l27.49,0a1.64,1.64,0,0,0,1.18-.49l4.74-4.74a1.7,1.7,0,0,1,1.18-.49l11.59-.08A1.67,1.67,0,0,1,134.94,413.18Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.48,
    y: 414.15,
    width: 48.83,
    height: 29.18,
    transform: "translate(222.93 856.66) rotate(179.58)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.11,416.56,134.6,447a1.07,1.07,0,0,1-1.06,1L86,448.32a1.08,1.08,0,0,1-1.08-1l-2.62-30.41a1.07,1.07,0,0,1,1.06-1.17l53.72-.39A1.08,1.08,0,0,1,138.11,416.56Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.09,408.5l-1.35,24.84a1.67,1.67,0,0,1-1.66,1.58l-44.69.33a1.67,1.67,0,0,1-1.69-1.67l-.15-19.33a1.69,1.69,0,0,1,1.68-1.69l27.49,0a1.68,1.68,0,0,0,1.18-.49l4.74-4.74a1.68,1.68,0,0,1,1.18-.49l11.58-.09A1.68,1.68,0,0,1,148.09,408.5Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.09,408.5l-1.35,24.84a1.67,1.67,0,0,1-1.66,1.58l-44.69.33a1.67,1.67,0,0,1-1.69-1.67l-.15-19.33a1.69,1.69,0,0,1,1.68-1.69l27.49,0a1.68,1.68,0,0,0,1.18-.49l4.74-4.74a1.68,1.68,0,0,1,1.18-.49l11.58-.09A1.68,1.68,0,0,1,148.09,408.5Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 98.63,
    y: 409.46,
    width: 48.83,
    height: 29.18,
    transform: "translate(249.19 847.19) rotate(179.58)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.26,411.87l-3.51,30.46a1.07,1.07,0,0,1-1.06.95l-47.59.35a1.06,1.06,0,0,1-1.08-1L95.4,412.24a1.08,1.08,0,0,1,1.06-1.18l53.72-.39A1.08,1.08,0,0,1,151.26,411.87Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.26,411.87l-3.51,30.46a1.07,1.07,0,0,1-1.06.95l-47.59.35a1.06,1.06,0,0,1-1.08-1L95.4,412.24a1.08,1.08,0,0,1,1.06-1.18l53.72-.39A1.08,1.08,0,0,1,151.26,411.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M162.91,414.31l-1.35,24.84a1.68,1.68,0,0,1-1.66,1.59l-44.7.33a1.69,1.69,0,0,1-1.69-1.67l-.14-19.33a1.69,1.69,0,0,1,1.68-1.69l27.49,0a1.64,1.64,0,0,0,1.18-.49l4.74-4.74a1.68,1.68,0,0,1,1.18-.49l11.58-.08A1.67,1.67,0,0,1,162.91,414.31Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.45,
    y: 415.28,
    width: 48.83,
    height: 29.18,
    transform: "translate(278.87 858.71) rotate(179.58)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.08,417.69l-3.51,30.46a1.07,1.07,0,0,1-1.06,1l-47.59.35a1.09,1.09,0,0,1-1.09-1l-2.61-30.41a1.07,1.07,0,0,1,1.06-1.17l53.72-.39A1.08,1.08,0,0,1,166.08,417.69Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,421.83v42.25h61V421.83Zm19.9,7.6a3.12,3.12,0,0,1,3.12-3.12h14.91a3.12,3.12,0,0,1,0,6.24H133.23A3.12,3.12,0,0,1,130.11,429.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.35,421.83v42.25h32.86V421.83Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.af6e8574259e6f7ddfef5ce81b9b1ea9.svg";
export { ForwardRef as ReactComponent };